<template>
  <div>
    <Layout
      username="Administrator"
      current-page="Add Company"
      link-to-edit="/admin-dashboard/edit-profile"
    >
      <template slot="menuItems">
        <li
          v-for="{ title, icon, path } in menu"
          :key="title"
          class="nav-item"
        >
          <MenuItems
            :menu-item="title"
            :icon-menu="icon"
            :to-where="path"
          />
        </li>
      </template>
      <template slot="messages">
        <div
          v-if="alert.message"
          :class="`alert ${alert.type} alert-dismissible fade show`"
          role="alert"
        >
          {{ alert.message }}
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
      <template slot="content">
        <div
          class="jumbotron justify-content-center d-sm-none d-md-block col-lg-8 mr-sm-0 ml-sm-0"
        >
          <ValidationObserver v-slot="{ invalid }">
            <form @submit.prevent="add">
              <ValidationProvider
                v-for="input in inputs"
                :key="input.name"
                v-slot="{ errors }"
                mode="aggressive"
                :rules="input.rules"
                persist
              >
                <div class="form-group">
                  <label :for="input.name">{{ input.label }}</label>
                  <input
                    v-model="input.value"
                    :name="input.name"
                    :type="input.type"
                    :placeholder="input.placeholder"
                    class="form-control"
                    :class="{'is-invalid': errors[0]}"
                  >
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </div>
              </ValidationProvider>
              <ul>
                <li 
                  v-for="dbError of dbErrors"
                  :key="dbError"
                  class="custom-error"
                >
                  {{ dbError }}
                </li>
              </ul>
              <div class="d-flex flex-row-reverse mt-3">
                <button
                  type="submit"
                  class="btn btn-primary p2"
                  :disabled="invalid"
                >
                  Add Company
                  <span
                    v-if="wait"
                    class="spinner-grow spinner-grow-sm text-light"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </span>
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </template>
    </Layout>
  </div>
</template>

<script>
import Layout from "../../components/Layout";
import MenuItems from "../../components/MenuItems";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  name: "Addcompany",
  components: {
    Layout,
    MenuItems,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      wait: false,
      inputs: [
        {
          label: "Company Name",
          name: "companyName",
          type: "text",
          rules: "required",
          value: "",
          placeholder: "x ltd.",
        },
        {
          label: "Company Email",
          name: "companyName",
          type: "email",
          rules: "required|email",
          value: "",
          placeholder: "email@company.com",
        },
        {
          label: "Company Address",
          name: "companyAddress",
          type: "text",
          rules: "required|min:7",
          value: "",
          placeholder: "KG number st",
        },
        {
          label: "Company Phone",
          name: "companyPhone",
          type: "tel",
          rules: "required|phone|digits:10",
          value: "",
          placeholder: "0788888888",
        },
        {
          label:"Password",
          name:'password',
          type:'password',
          rules:'required',
          value:'',
        }
      ],
      menu: [
        {
          title: "Dashboard",
          icon: "fa fa-chart-line",
          path: "/admin",
        },
        {
          title: "Add Company",
          icon: "fa fa-plus",
          path: "/admin/companies/new",
        },
        {
          title: "Companies",
          icon: "fa fa-table",
          path: "/admin/companies",
        },
        {
          title: "Sales",
          icon: "fa fa-table",
          path: "/admin/admin-sales",
        },
      ],
      dbErrors:{}
    };
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    },
  },
  methods: {
    add: function () {
      this.dbErrors = {}
      let name = this.inputs[0].value;
      let email = this.inputs[1].value;
      let address = this.inputs[2].value;
      let phoneNumber = this.inputs[3].value;
      let password = this.inputs[4].value;
      this.wait = true;
      this.$store
        .dispatch("admin/add", {
          name,
          email,
          address,
          phoneNumber,
          password
        })
        .then(() => {
          this.wait= false
          this.$router.push({ name: "adminreports" });
        }).catch(err => {
          this.wait = false
          this.dbErrors = err
        })
    },
    clear: function () {
      this.$store.dispatch("alert/clear");
    },
  },
};
</script>

<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}
</style>
